import ApiService from '@/services/core/api.service'

const CompanyService = {
  async get (query) {
    return ApiService.get(`logistics-officer/companies?${query}`)
  },

  async post (payload) {
    return ApiService.post('logistics-officer/companies', payload)
  },

  async put (payload) {
    return ApiService.put(`logistics-officer/companies/${payload.id}`, payload)
  }
}

export default CompanyService
